import { render, staticRenderFns } from "./PermissonSetting.vue?vue&type=template&id=772cee39&scoped=true"
import script from "./PermissonSetting.vue?vue&type=script&lang=ts"
export * from "./PermissonSetting.vue?vue&type=script&lang=ts"
import style0 from "./PermissonSetting.vue?vue&type=style&index=0&id=772cee39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772cee39",
  null
  
)

export default component.exports